var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBikeMotorblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74805 1.72852H6.81592V7.5538H7.74805V1.72852Z",
    fill: "#201F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28261 6.15409C8.11907 6.15409 8.79716 5.47601 8.79716 4.63955C8.79716 3.80309 8.11907 3.125 7.28261 3.125C6.44615 3.125 5.76807 3.80309 5.76807 4.63955C5.76807 5.47601 6.44615 6.15409 7.28261 6.15409Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2825 5.77592C7.9099 5.77592 8.41851 5.26731 8.41851 4.63991C8.41851 4.01251 7.9099 3.50391 7.2825 3.50391C6.6551 3.50391 6.14648 4.01251 6.14648 4.63991C6.14648 5.26731 6.6551 5.77592 7.2825 5.77592Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46612 2.19536H6.02135L4.85628 1.18594H0.447754V0.253906H5.20396L6.36903 1.26333H8.11844L9.28346 0.253906H14.1175V1.18594H9.63119L8.46612 2.19536Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45739 17.224H8.52536V9.06869C8.52536 8.34053 7.93307 7.74844 7.20512 7.74844C6.47696 7.74844 5.88467 8.34053 5.88467 9.06869V17.2241H4.95264V9.06869C4.95264 7.82675 5.96318 6.81641 7.20512 6.81641C8.44705 6.81641 9.45739 7.8267 9.45739 9.06869V17.224Z",
    fill: "#ABABAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55198 0H0V1.45632H3.55198V0Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6789 0H11.127V1.45632H14.6789V0Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43784 24.0002H6.97239C6.69072 24.0002 6.4624 23.7719 6.4624 23.4903V9.88889C6.4624 9.60722 6.69072 9.37891 6.97239 9.37891H7.43784C7.71951 9.37891 7.94783 9.60722 7.94783 9.88889V23.4902C7.94783 23.7719 7.71951 24.0002 7.43784 24.0002Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46186 16.3105H5.88428V16.6305H6.46186V16.3105Z",
    fill: "#666666"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9506 16.3105H3.90674V16.6305H4.9506V16.3105Z",
    fill: "#666666"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6215 19.9316H3.57764V20.2516H4.6215V19.9316Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52534 16.3105H7.94775V16.6305H8.52534V16.3105Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 16.3105H9.45605V16.6305H10.4999V16.3105Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2182 12.7578H10.1743V13.0778H11.2182V12.7578Z",
    fill: "#666666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6418 16.0566H4.09814V20.2519H4.6418V16.0566Z",
    fill: "#212121"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2487 12.7578H9.70508V16.953H10.2487V12.7578Z",
    fill: "#212121"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90426 19.3555H2.15674V20.8313H3.90426V19.3555Z",
    fill: "#666666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2475 12.1797H10.5V13.6555H12.2475V12.1797Z",
    fill: "#666666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7518 7.5H29.2485C30.4604 7.5 31.449 8.85 31.449 10.5048V19.65C31.449 20.3903 31.0025 21 30.4604 21H23.5399C22.9978 21 22.5513 20.3903 22.5513 19.65V10.5048C22.5513 8.85 23.5399 7.5 24.7518 7.5Z",
    fill: "#ABABAB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5508C28.1455 16.5508 29.0455 17.4611 29.0455 18.6197V21.9301C29.0455 23.0887 28.1455 23.9991 27 23.9991C25.8546 23.9991 24.9546 23.0887 24.9546 21.9301V18.6197C24.9546 17.4611 25.8546 16.5508 27 16.5508Z",
    fill: "#212121"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0003 13.6543C28.8003 13.6543 30.273 15.144 30.273 16.9646V18.6198H23.7275V16.9646C23.7275 15.144 25.2003 13.6543 27.0003 13.6543Z",
    fill: "#DEDEDE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1816 11.5859H27.818V12.4135H26.1816V11.5859Z",
    fill: "#212121"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1816 9.93164H27.818V10.7592H26.1816V9.93164Z",
    fill: "#212121"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1138 4.13867H35.182V4.96626H32.1138V4.13867Z",
    fill: "#212121"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8184 4.13867H21.8456V4.96626H18.8184V4.13867Z",
    fill: "#212121"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.909 4.01443H31.0908V1.65581C31.0908 1.49029 31.1726 1.32477 31.3363 1.28339L33.6272 0.373047L33.9545 1.11787L31.909 1.94546V4.01443Z",
    fill: "#666666"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5454 0H36V1.65517H33.5454V0Z",
    fill: "#666666"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9092 4.13698H22.091V1.94387L20.0864 1.11629L20.3728 0.330078L22.6228 1.24042C22.8273 1.32318 22.9092 1.4887 22.9092 1.65422V4.13698Z",
    fill: "#666666"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H20.4545V1.65517H18V0Z",
    fill: "#666666"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3185 5.37979L28.2276 6.20738H25.773L21.6821 5.37979V3.72461H32.3185V5.37979Z",
    fill: "#DEDEDE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7.862C28.3556 7.862 29.4545 6.75043 29.4545 5.37924C29.4545 4.00805 28.3556 2.89648 27 2.89648C25.6443 2.89648 24.5454 4.00805 24.5454 5.37924C24.5454 6.75043 25.6443 7.862 27 7.862Z",
    fill: "#212121"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 7.03496C27.9034 7.03496 28.636 6.29391 28.636 5.37978C28.636 4.46566 27.9034 3.72461 26.9996 3.72461C26.0959 3.72461 25.3633 4.46566 25.3633 5.37978C25.3633 6.29391 26.0959 7.03496 26.9996 7.03496Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeMotorblack);
export default __webpack_public_path__ + "static/media/bikeMotorblack.3b97b41ad0da2867871bc45005a3f6bc.svg";
export { ForwardRef as ReactComponent };